<div style="padding: 2%; background-color: white;">
  <div class="logo parent">
    
     <div><h3>{{"Customer Contact" | translate | async}}</h3></div> 
    
    
  </div>
  <div class="search">

    
      <mat-form-field class="example-full-width" >
        
        <mat-select [(ngModel)]="selectedCustomer" name="customer" [placeholder]="'Select Customer' | translate | async">
          <mat-option *ngFor="let option of CustomerList" [value]="option.customerId"   (click)="onChangeCustomer()" id="cmbusers">
            {{option.customerName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      
      

    <mat-form-field style="margin: 10px;">
      <mat-label>{{"Contains" | translate | async}}</mat-label>
       <mat-select>
        <mat-option *ngFor="let contain of contain" [value]="contain.value">
          {{contain.viewValue}}
        </mat-option>
        
      </mat-select>
    </mat-form-field>
   
    <button mat-stroked-button class="AddNewUserBtn" (click)="openAddNewUserDialog()" [disabled]="isCustomerSelected !=true">{{"Add New User"  | translate | async}}</button>
    <button mat-stroked-button class="Reloadbtn" (click)="refreshPage()">{{"Reload"  | translate | async}}</button>
    <button mat-stroked-button class="ExportBtn" (click) ="DownloadCSVFile()">{{"Export All"  | translate | async}}</button>
  </div>
  <div *ngIf="showError"><span style="color: red;">{{"Please Select a Customer" | translate | async}}</span></div>
  <div class="tab">
    <h4>{{"Customer Contact Details"  | translate | async}}</h4>
    <mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z4" [(selectedIndex)]="selectedTab" style="background-color: white;">
      <mat-tab [label]="'Customer Level' | translate | async">
        <table>
           <thead> 
             <tr> 
                <th>{{"User" | translate | async}}</th>
                <th>A</th>
                <th>B</th>
                <th>C</th>
                <th>X</th>
                <th>{{"Email" | translate | async}}</th>
                <!-- <th>Warranty</th> -->
                <th>{{"Health" | translate | async}}</th>
                <th>{{"Under Carriage" | translate | async}}</th>
                <th></th>
              </tr> 
                </thead>
                 <tbody>
                    <tr *ngFor="let item of contactLsit"> 
                      <td>{{item.userName | aesDecrypt}}</td> 
                      
                      <td> <mat-checkbox  [checked]="item.EvalA" (change)='fieldsChange($event,item,1);'></mat-checkbox>
                      <td > <mat-checkbox  [checked]="item.EvalB"  (change)='fieldsChange($event,item,2);'></mat-checkbox>
                      <td > <mat-checkbox  [checked]="item.EvalC"  (change)='fieldsChange($event,item,3);'></mat-checkbox>
                      <td > <mat-checkbox  [checked]="item.EvalX"  (change)='fieldsChange($event,item,4);'></mat-checkbox>
                      <!-- <td > <mat-checkbox  [checked]="true" [disabled]="true" ></mat-checkbox> -->
                      <td > <mat-checkbox  [checked]="item.wty_letter"  (change)='fieldsChange($event,item,5);'></mat-checkbox>
                      <td > <mat-checkbox  [checked]="item.eq_health"  (change)='fieldsChange($event,item,6);'></mat-checkbox>
                      <td> <mat-checkbox  [checked]="item.eq_undercarriage"  (change)='fieldsChange($event,item,7);'></mat-checkbox>
                      <td> <mat-checkbox [(ngModel)]="item.checked"  (change)='fieldsChange_($event,item);'></mat-checkbox>
                      
                      
                  </tr>
                     </tbody>
                     </table>
          </mat-tab>

      <mat-tab [label]="'Job Site Level' | translate | async"><table>
        <thead> 
          <tr> 
            
             <th>{{"User" | translate | async}}</th>
             <th>A</th>
             <th>B</th>
             <th>C</th>
             <th>X</th>
             <th>{{"Email" | translate | async}}</th>
             <th>{{"Service" | translate | async}}</th>
             <th>U/C</th>
             <th>{{"Health" | translate | async}}</th>
             <th></th>
              
           </tr> 
             </thead>
              <tbody *ngFor="let cat of JobsiteListForTabGrouping">
                <tr>
                  <td style="font-weight: bold;background-color: #a39e9e29;">{{cat.site_name}}</td>
                  <td style="background-color: #a39e9e29;"></td>
                  <td style="background-color: #a39e9e29;"></td>
                  <td style="background-color: #a39e9e29;"></td>
                  <td style="background-color: #a39e9e29;"></td>
                  <td style="background-color: #a39e9e29;"></td>
                  <td style="background-color: #a39e9e29;"></td>
                  <td style="background-color: #a39e9e29;"></td>
                  <td style="background-color: #a39e9e29;"></td>
                  <td style="background-color: #a39e9e29;"></td>
                </tr>
                 <tr *ngFor="let item of JobsiteListForTab"> 
                  <ng-container  *ngIf="item.crsf_auto == cat.crsf_auto">
                    <td align="left" style="padding: 8px;">{{item.username | aesDecrypt}}</td>
                   
                  <td align ="left"> <mat-checkbox  [checked]="item.EvalA" (change)='fieldsChangeJobsite($event,item,1);'></mat-checkbox>
                  <td align ="left"> <mat-checkbox  [checked]="item.EvalB" (change)='fieldsChangeJobsite($event,item,2);'></mat-checkbox>
                  <td align ="left"> <mat-checkbox  [checked]="item.EvalC" (change)='fieldsChangeJobsite($event,item,3);'></mat-checkbox>  
                  <td align ="left"> <mat-checkbox  [checked]="item.EvalX" (change)='fieldsChangeJobsite($event,item,4);'></mat-checkbox>
                  <td align ="left"> <mat-checkbox  [checked]="item.wty_letter" (change)='fieldsChangeJobsite($event,item,5);'></mat-checkbox>
                  <td align ="left"> <mat-checkbox  [checked]="item.service" (change)='fieldsChangeJobsite($event,item,6);'></mat-checkbox>  
                  <td align ="left"> <mat-checkbox  [checked]="item.eq_undercarriage" (change)='fieldsChangeJobsite($event,item,7);'></mat-checkbox>     
                  <td align ="left"> <mat-checkbox  [checked]="item.eq_health" (change)='fieldsChangeJobsite($event,item,8);'></mat-checkbox>        
                    <td align ="left"> <mat-checkbox  [checked]="false" (change)='fieldsChangejobsite_($event,item);' ></mat-checkbox>
                    </ng-container>
                    </tr>
                  </tbody>
                  </table> </mat-tab>
      <!-- <mat-tab label="Equipment Level">
        <table>
          <thead> 
            <tr> 
              
               <th>Job Site</th>
               <th>Equipment</th>
               <th>User</th>
               <th>A</th>
               <th>B</th>
               <th>C</th>
               <th>X</th>
               <th>Email</th>
               <th>Service</th>
               <th>U/C</th>
               <th>Health</th>
               <th></th>
               
                
             </tr> 
               </thead>
                <tbody>
                   <tr *ngFor="let item of EquipmentListForTab"  > 
                     
                    <td align ="left" >{{ item.siteName}}</td>
                     <td align ="left">{{ item.serialno}}</td>
                     <td align ="left">{{ item.userName}}</td> 
                     
                     <td align ="left"> <mat-checkbox  [checked]="item.EvalA" (change)='fieldsChangeEquipment($event,item,1);'></mat-checkbox>
                      <td align ="left"> <mat-checkbox  [checked]="item.EvalB" (change)='fieldsChangeEquipment($event,item,2);'></mat-checkbox>
                      <td align ="left"> <mat-checkbox  [checked]="item.EvalC" (change)='fieldsChangeEquipment($event,item,3);'></mat-checkbox>  
                      <td align ="left"> <mat-checkbox  [checked]="item.EvalX" (change)='fieldsChangeEquipment($event,item,4);'></mat-checkbox>
                      <td align ="left"> <mat-checkbox  [checked]="item.wty_letter" (change)='fieldsChangeEquipment($event,item,5);'></mat-checkbox>
                      <td align ="left"> <mat-checkbox  [checked]="item.service" (change)='fieldsChangeEquipment($event,item,6);'></mat-checkbox>  
                      <td align ="left"> <mat-checkbox  [checked]="item.eq_undercarriage" (change)='fieldsChangeEquipment($event,item,7);'></mat-checkbox>     
                      <td align ="left"> <mat-checkbox  [checked]="item.eq_health" (change)='fieldsChangeEquipment($event,item,8);'></mat-checkbox>        
                      <td align ="left"> <mat-checkbox  [checked]="false"  (change)='fieldsChangeEquipment_($event,item);'></mat-checkbox>
                    
                   
                 </tr>
                    </tbody>
                    </table> </mat-tab> -->
    </mat-tab-group>
  </div>
  <div class="dltbtn" >
    <button id="btnbtn11" mat-stroked-button class="updatebtn" style="background-color:#ED5565 ;
    color: white;" (click)="update()" >{{"Update Selected" | translate | async}}</button>
    <button mat-stroked-button class="deletebtn" (click) = "delete()"style="background-color:#ED5565 ;
    color: white;" >{{"Delete Selected" | translate | async}}</button>
  </div>
</div>
<router-outlet></router-outlet>
 



